module.exports = __webpack_public_path__ + "img/phone2.aef8b096.png";